export const EVENT_TYPES = Object.freeze({
  GET_STARTED_BUTTON: 'GET_STARTED_BUTTON',
  CHAT_TIMEOUT: 'CHAT_TIMEOUT',
  CHAT_ENDED: 'CHAT_ENDED',
  CHAT_OPENED: 'CHAT_OPENED',
  CUSTOM_EVENT: 'CUSTOM_EVENT'
})

export const EVENTS = [{
  type: EVENT_TYPES.GET_STARTED_BUTTON,
  name: 'Welcome Message',
  description: 'When a customer begins a chat session. Greet them before they have typed anything.'
}, {
  type: EVENT_TYPES.CHAT_TIMEOUT,
  name: 'Chat Timeout',
  description: 'Triggered after 5 minutes of inactivity from either operator or customer.'
}, {
  type: EVENT_TYPES.CHAT_ENDED,
  name: 'Chat Ended',
  description: 'Occurs when an operator ends the chat session.'
}, {
  type: EVENT_TYPES.CHAT_OPENED,
  name: 'Web Chat Opened',
  description: 'Triggers when customer opens the web chat after certain period of time (usually 24 hours). Amio Chat only.'
}, {
  type: EVENT_TYPES.CUSTOM_EVENT,
  name: 'Custom Event',
  description: 'A custom event that can be triggered from your webpage after you have implemented the generated script'
}]

export const MENU_ITEMS = {
  reindexAllSources: { label: 'Reindex all sources', component: 'reindex-icon', emit: 'reindex-all-sources', itemExists: true, classes: '' },
  rename: { label: 'Rename', component: 'edit-icon', emit: 'rename', itemExists: true, classes: '' },
  copy: {
    label: 'Copy code',
    component: 'vs-icon',
    icon: 'code',
    emit: 'copy-code',
    itemExists: true,
    size: '1.3rem',
    classes: 'flex items-center'
  },
  delete: {
    label: 'Delete',
    component: 'delete-icon',
    emit: 'delete',
    itemExists: true,
    classes: 'text-focus-error'
  },
  show: { label: 'View Usages', component: 'eye-icon', emit: 'show', itemExists: true, classes: '' },
  copyChatUrl: {
    label: 'Copy demo chat URL',
    component: 'vs-icon',
    icon: 'link',
    emit: 'copy-chat-url',
    itemExists: true,
    classes: ''
  }
}

export const ITEM_IDS = {
  UNKNOWN: 'unknown',
  NEW: 'new'
}

export const ITEM_NAMES = {
  ANSWER: 'answer',
  EVENT: 'event',
  BLOCK: 'block',
  THEME: 'theme'
}

export const SAVE_BUTTON_VARIANTS = {
  DEFAULT: 'primary',
  ERROR: 'error',
  SUCCESS: 'success'
}
